import { React, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import table from '../assets/images/table.png'
import { faAdd, faCircleInfo, faClose, faEdit, faEye, faEyeSlash, faInfo, faLock, faPerson, faRemove, faSave, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SHOW_CONFIRM_ALERT, TOAST } from "../utils/Helpers";
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { url } from "../config/BaseUrl";
import waiterIcon from "../assets/images/waiter.png";
const Waiters = () => {

    useEffect(() => {
        getWaiters()
    }, [])

    const [isShowNewWaiterModal, showNewWaiterModal] = useState(false)
    const [selectedWaiter, setSelectedWaiter] = useState(null)
    const [isShowConfirmModal, showConfirmModal] = useState(false)
    const [isUpdating, setUpdating] = useState(false)
    const [name, setName] = useState("")
    const [password, setPassword] = useState("")
    const [waiters, setWaiters] = useState([])
    const [isShowPassword, setShowPassword] = useState(false)

    async function getWaiters() {

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }

        url.get("waiters/" + localStorage.getItem("shop_id"), { headers: headers })
            .then((response) => {
                setWaiters(response.data)
            })
            .catch((error) => console.log(error))
    }

    function addWaiter() {

        if(name === ""){
            TOAST("Veuillez saisir le nom", "error")
            return
        }

        // if(password === ""){
        //     TOAST("Veuillez saisir le mot de passe", "error")
        //     return
        // }

        // if(password.length <2 || !/^\d+$/.test(password)){
        //     TOAST("Le mot de passe doit être composé de 2 chiffres", "error")
        //     return
        // }

        setUpdating(true)
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
        url.post("waiters/", { name: name, password: 11, shop: localStorage.getItem("shop_id") }, { headers: headers })
            .then((response) => {
                console.log("addBlackList", response)
                TOAST("Employé ajouté avec succès.", "success")
                resetStates()
                getWaiters()
            })
            .catch((error) => {
                console.log(error)
                TOAST(error.response?.data?.message, "error")
                setUpdating(false)
            })
            
    }

    function updateWaiter() {

        setUpdating(true)
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
        url.put("waiters/" + selectedWaiter?._id, { name: name, password: 11, shop: localStorage.getItem("shop_id") }, { headers: headers })
            .then((response) => {
                console.log("addBlackList", response)
                TOAST("Employé mis à jour avec succès.", "success",)
                resetStates()
                getWaiters()
            })
            .catch((error) => {
                console.log(error)
                TOAST(error.response?.data?.message, "error")
                setUpdating(false)
            })
    }

    function deleteWaiter() {

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
        url.delete("waiters/" + selectedWaiter?._id, { headers: headers })
            .then((response) => {
                TOAST("Employé supprimé avec succès.", "success",)
                resetStates()
                getWaiters()
            })
            .catch((error) => {
                console.log(error)
                TOAST(error.response?.data?.message, "error")
            })
    }

    function resetStates() {

        setName("")
        setPassword("")
        setSelectedWaiter(null)
        showNewWaiterModal(false)
        showConfirmModal(false)
        setUpdating(false)
    }

    return (
        <>
            <div className="h-[calc(100vh)] w-full flex bg-slate-100 inset-0">
                <div className="w-full" style={{ backgroundColor: "#E8E7FB" }}>
                    <div className="flex w-full justify-between mt-5 px-10">
                        <h1 className="text-[30px] font-semibold ">Employés ({waiters.length})</h1>
                        <button
                            className="flex gap-3 items-center justify-center text-black font-semibold uppercase text-xl rounded py-5 px-10"
                            style={{ border: '1px solid #000' }}
                            onClick={() => showNewWaiterModal(true)}
                            type="button">
                            <FontAwesomeIcon icon={faAdd} style={{ color: "#000", height: 25, width: 25 }} />
                            Nouveau employé
                        </button>
                    </div>

                    <div className="flex items-center justify-center py-5 px-10">
                        <div className="w-full">
                            <div className="flex gap-3 items-center overflow-auto lg:overflow-visible grid grid-cols-3 lg:grid-cols-3 ">
                                {waiters.map(waiter => (
                                    <div className="flex flex-col w-full items-center justify-center border-2 border-gray-200 rounded bg-white shadow-xl pt-[15px] pb-[10px] px-5">
                                        <img alt="" src={waiterIcon} style={{ color: "#000", height: 100, width: 100 }} />
                                        <p className="text-3xl text-center mt-5">{waiter.name}</p>
                                        <div className="flex flex-col w-full h-full gap-2 mt-5">
                                            <button
                                                className="flex gap-3 w-full items-center justify-center text-primary font-medium uppercase text-md rounded py-2"
                                                style={{ border: '1px solid #F01F2C' }}
                                                onClick={() => { setSelectedWaiter(waiter); showConfirmModal(true) }}
                                                type="button">
                                                <FontAwesomeIcon icon={faRemove} style={{ color: "#F01F2C", height: 25, width: 25 }} />
                                                SUPPRIMER
                                            </button>
                                            <button
                                                className="flex gap-3 w-full items-center justify-center text-info font-medium uppercase text-md rounded py-2"
                                                style={{ border: '1px solid #000' }}
                                                onClick={() => { setSelectedWaiter(waiter); setName(waiter.name); setPassword(waiter.password); showNewWaiterModal(true) }}
                                                type="button">
                                                <FontAwesomeIcon icon={faEdit} style={{ color: "#000", height: 20, width: 20 }} />
                                                Modifier
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                open={isShowConfirmModal}
                maxWidth='md'
                onClose={() => showConfirmModal(false)}
                className="modalWrapper">
                <DialogTitle>
                    <p className="text-[25px]">Êtes vous sûr vouloir supprimer l'employé?</p>
                </DialogTitle>
                <DialogActions>
                    <button
                        className="bg-black flex gap-3 w-full items-center justify-center text-white font-bold uppercase text-xl py-5"
                        onClick={() => showConfirmModal(false)}>
                        Annuler
                    </button>
                    <button
                        className="bg-primary flex gap-3 w-full items-center justify-center text-white font-medium uppercase text-xl py-5"
                        onClick={() => deleteWaiter()}>
                        Supprimer
                    </button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={isShowNewWaiterModal}
                maxWidth='lg'
                fullWidth
                onClose={() => resetStates()}
                className="modalWrapper">
                <DialogTitle>
                    <p className="font-bold text-[25px]">{selectedWaiter ? "Modifier " + selectedWaiter?.name : "Nouveau employé"}</p>
                </DialogTitle>
                <DialogContent>
                    <div className="flex gap-5 items-center mt-[25px]">
                        <FontAwesomeIcon icon={faUser} style={{ color: "#000", height: 25, width: 25 }} />
                        <input
                            type="text"
                            id="default-search"
                            className="block px-6 text-xl mt-2 text-gray-900 border-0 h-[60px]"
                            placeholder={"Taper le nom"}
                            value={name}
                            onChange={(event) => setName(event.target.value)}
                            required
                            style={{ color: '#000', backgroundColor: '#fff', border: '1px solid #000' }}
                        />
                    </div>

                    {/* <div className="flex gap-5 items-center mt-[15px]">
                        <FontAwesomeIcon icon={faLock} style={{ color: "#000", height: 25, width: 25 }} />
                        <div className="flex items-center pr-5" style={{ border: '1px solid black' }}>
                            <input
                                type={isShowPassword ? "text" : "password"}
                                max={4}
                                id="default-search"
                                className="block px-6 text-xl text-gray-900 border-0 h-[60px]"
                                placeholder={"Mot de passe"}
                                value={password}
                                onChange={(event) => setPassword(event.target.value)}
                                required
                                style={{ color: '#000', backgroundColor: '#fff', border: '0px solid #000' }}
                            />
                            <FontAwesomeIcon onClick={() => setShowPassword(!isShowPassword)} icon={isShowPassword ? faEyeSlash : faEye} style={{ color: "#000", height: 25, width: 25 }} />
                        </div>

                        <i>(2 chiffres)</i>
                    </div> */}
                </DialogContent>
                <DialogActions>
                    <div className="flex w-full border-t mt-5">
                        <button
                            className="bg-black flex gap-3 w-full items-center justify-center text-white font-bold uppercase text-xl py-6"
                            type="button"
                            onClick={() => resetStates(false)}>
                            <FontAwesomeIcon icon={faClose} style={{ color: "#fff", height: 25, width: 25 }} />
                            FERMER
                        </button>
                        <button
                            className="bg-primary flex gap-3 w-full items-center justify-center text-white font-medium uppercase text-xl py-6"
                            type="button"
                            onClick={() => selectedWaiter ? updateWaiter() : addWaiter()}>
                            {isUpdating
                                ? <CircularProgress size={40} style={{ color: 'white' }} />
                                : <><FontAwesomeIcon icon={faSave} style={{ color: "#fff", height: 25, width: 25 }} />Enregistrer</>
                            }
                        </button>

                    </div>
                </DialogActions>

            </Dialog>
        </>
    )
}

function mapStateToProps(state) {
    return {
    }
}

export default connect(mapStateToProps)(Waiters);